import { NgModule } from "@angular/core";
import { PageTitleComponent } from "@app/components/page-title/page-title.component";

@NgModule({
  declarations: [
    PageTitleComponent,
  ],
  imports: [],
  exports: [
    PageTitleComponent,
  ],
})
export class PageTitleModule {}
